import { render, staticRenderFns } from "./CreateRecommended.html?vue&type=template&id=bf883d6e&scoped=true&external"
import script from "./CreateRecommended.vue?vue&type=script&lang=js"
export * from "./CreateRecommended.vue?vue&type=script&lang=js"
import style0 from "./CreateRecommended.scss?vue&type=style&index=0&id=bf883d6e&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf883d6e",
  null
  
)

export default component.exports